import React, { useEffect, Component } from "react"
import { GoogleMap, useJsApiLoader, LoadScript, InfoWindow, Marker} from "@react-google-maps/api"

import marker_icon from "../../maps/img/search_map_marker.png";
import { mapStyles, GOOGLE_MAP_API_KEY } from "./constants"

const PropertyDetailMap = (props) => {
  const containerStyle = {
    width: "100%",
    height: props.height,
  }

  const center = {
    lat: props.lat,
    lng: props.lng,
  }

  const position = {
    lat: props.lat,
    lng: props.lng,
  }

  const [map, setMap] = React.useState(null); 
  //const [near_by_place, setNearByPlaces] = React.useState([]); 

  const [currentInfo, setCurrentInfo] = React.useState('');

  // const onLoad = React.useCallback(function callback(map) {
  //   // This is just an example of getting and using the map instance!!! don't just blindly copy!
    
  //   //const bounds = new window.google.maps.LatLngBounds(center);
  //   // map.fitBounds(bounds);

  //   const request = {
  //     location: center,
  //     radius: 6000,
  //     type: ['university']  // bar, bus_station, cafe, convenience_store, dentist, doctor, hospital, laundry, library, liquor_store, night_club, pharmacy, post_office, train_station, transit_station, university
  //   };

  //   var service = new window.google.maps.places.PlacesService(map);
  //   service.nearbySearch(request, (results, status) => {
  //     if (status == google.maps.places.PlacesServiceStatus.OK) {
  //         console.log("results ==>", results);
  //         setNearByPlaces(results);
  //     }
  //   })
  //   //map.fitBounds(service);
  //   //setMap(map)

  // }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, []);

  const onMarkerClick = (infoId, e) => {
    //setShowingInfoWindow(true);
    if(infoId === currentInfo){
      setCurrentInfo('')
    } else{
      setCurrentInfo(infoId)
    }
    
  }

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.GATSBY_MAPS_API_KEY,
    libraries:["places"]
  })

  //console.log("near_by_place", near_by_place);

  return isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={12}
        onUnmount={onUnmount} 
        //onLoad={onLoad}
        options={{ styles: mapStyles, streetViewControl:false, mapTypeControl: true}}
      >
        <Marker position={position} icon={marker_icon}></Marker>

      </GoogleMap>
    
  ) : <></>
}

export default React.memo(PropertyDetailMap)